import { useCallback } from 'react';
import { useAtom } from 'jotai';
import {
    paymentPopupOpenAtom,
    paymentPopupUuidAtom,
    paymentPopupStripeAccountAtom,
    paymentPopupPaymentIdAtom,
} from '../states/payment-popup-atoms';

/**
 * Custom hook for managing payment popup state and logic
 * @returns Object containing popup state and control functions
 */
export const usePaymentPopup = () => {
    const [isPaymentPopupOpen, setIsPaymentPopupOpen] =
        useAtom(paymentPopupOpenAtom);
    const [currentUuid, setCurrentUuid] = useAtom(paymentPopupUuidAtom);
    const [stripeAccount, setStripeAccount] = useAtom(
        paymentPopupStripeAccountAtom
    );
    const [currentPaymentId, setCurrentPaymentId] = useAtom(
        paymentPopupPaymentIdAtom
    );

    const openPopup = useCallback(
        (
            uuid: string,
            stripeAccountParam: string | null,
            paymentId?: number
        ) => {
            setCurrentUuid(uuid);
            setIsPaymentPopupOpen(true);
            setStripeAccount(stripeAccountParam);
            setCurrentPaymentId(paymentId || 0);
        },
        [
            setCurrentUuid,
            setIsPaymentPopupOpen,
            setStripeAccount,
            setCurrentPaymentId,
        ]
    );

    const closePopup = useCallback(() => {
        setIsPaymentPopupOpen(false);
        setCurrentUuid('');
        setStripeAccount(null);
        setCurrentPaymentId(0);
    }, [
        setIsPaymentPopupOpen,
        setCurrentUuid,
        setStripeAccount,
        setCurrentPaymentId,
    ]);

    return {
        isPaymentPopupOpen,
        openPopup,
        closePopup,
        currentUuid,
        stripeAccount,
        currentPaymentId,
    };
};
